import {identity} from '@packages/utilities/fp/utils';
import {type Json} from '@packages/utilities/json';
import {
  type QualifiedMap,
  type TypeName,
} from '@packages/systems/wfdl-Qualified';
import * as Result from '../Result';

import * as VariableMap from '../VariableMap';

export type Value = any;

export type ValueParser = (arg1: Json) => Result.ResultType<string, unknown>;

type EvalEnvShape = {
  parsers: QualifiedMap<TypeName, ValueParser>;
  values: VariableMap.Map<Value>;
};

// Opaque type removed - see /packages/utilities/type-safety/README.md for more information
export type EvalEnvType = EvalEnvShape;

export const create: (arg1: EvalEnvShape) => EvalEnvType = identity;

export const getParsers = (
  env: EvalEnvType
): QualifiedMap<TypeName, ValueParser> => env.parsers;

export const getValues = (env: EvalEnvType): VariableMap.Map<Value> =>
  env.values;
